import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AviumLogo from './AviumLogo';

/**
 * PublicHeader — the top navigation for the public marketing site (homepage and,
 * over time, the /learn /for /blog sections). This is the PRIMARY nav for
 * prospects; the login page is no longer the front door. "Why Avium" opens the
 * brochure; Learn/For link the SEO hubs; Sign in / Start free go to the app.
 * (Blog + Pricing slot in here once those pages exist.)
 *
 * The header's "Start free" CTA stays HIDDEN at the top of the page and fades in
 * only once the visitor scrolls past the hero — because every public page's hero
 * already owns the "Start free" conversion. Without this, the sticky header's
 * CTA and the hero CTA sit in the same viewport as two identical buttons. This
 * way exactly one "Start free" is visible at any scroll position: the hero's up
 * top, the header's once the hero scrolls away. "Sign in" stays always visible.
 */
export default function PublicHeader() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 360);
    onScroll(); // honor a restored scroll position on mount
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-30 bg-brand-primary-dark/95 backdrop-blur border-b border-white/10 text-white">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between gap-6">
        <Link to="/" className="inline-flex items-center gap-2 shrink-0">
          <AviumLogo size={32} variant="dark" />
          <span className="font-extrabold text-xl tracking-tight">Avium</span>
        </Link>

        <nav className="hidden md:flex items-center gap-7 text-sm font-medium text-teal-100">
          <a href="/sales-brochure.html" className="hover:text-white transition-colors">Why Avium</a>
          <Link to="/demo" className="hover:text-white transition-colors">Demo</Link>
          <Link to="/learn" className="hover:text-white transition-colors">Learn</Link>
          <Link to="/for" className="hover:text-white transition-colors">For your role</Link>
          <Link to="/blog" className="hover:text-white transition-colors">Blog</Link>
        </nav>

        <div className="flex items-center gap-2 sm:gap-4 shrink-0">
          <Link to="/login" className="text-sm font-semibold text-teal-100 hover:text-white transition-colors">
            Sign in
          </Link>
          <Link
            to="/login"
            aria-hidden={!scrolled}
            tabIndex={scrolled ? 0 : -1}
            className={`text-sm font-semibold bg-brand-spark hover:bg-brand-spark-dark text-white px-4 py-2 rounded-md transition-opacity duration-300 ${scrolled ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
          >
            Start free →
          </Link>
        </div>
      </div>
    </header>
  );
}
